import { Button } from 'components/Button';
import { Text } from 'components/Text';
import { Modal } from 'components/modal/Modal';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { FormGroup } from 'components/form/FormGroup';
import { FormField } from 'components/form/FormField';
import { FormInput } from 'components/form/FormInput';
import { FormDate } from 'components/form/FormDate';
import { FormEmail } from 'components/form/FormEmail';
import SignaturePad from 'react-signature-canvas';
import './ModalSignature.scss';
/**
 * @component ModalSignature
 * @since 1.0.0
 * @hidden
 */
export function ModalSignature(props) {
    var _a;
    const { deal, onClose, onSignatureCompleted, signatureData } = props;
    const signaturePad = useRef(null);
    const [signatureDataValue, setSignatureData] = useState(signatureData);
    useEffect(() => {
        var _a, _b;
        setSignatureData(signatureData);
        (_a = signaturePad.current) === null || _a === void 0 ? void 0 : _a.fromDataURL((_b = signatureData === null || signatureData === void 0 ? void 0 : signatureData.signatureBase64) !== null && _b !== void 0 ? _b : '');
    }, [signatureData]);
    /**
     * @function onSign
     * @since 1.0.0
     * @hidden
     */
    function onSign() {
        if (signatureDataValue) {
            onSignatureCompleted(signatureDataValue);
        }
    }
    /**
     * @function clearSignature
     * @since 1.0.0
     * @hidden
     */
    const onPressClearSignature = () => {
        var _a;
        (_a = signaturePad.current) === null || _a === void 0 ? void 0 : _a.clear();
        setSignatureData(null);
    };
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: () => onClose() }),
        React.createElement(Button, { style: "primary", label: t('Sign'), onPress: onSign, disabled: !(signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.signatureBase64) ||
                !(signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.firstName) ||
                !(signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.lastName) ||
                !(signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.email) ||
                !(signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.date) })));
    return (React.createElement("div", { className: "modal-signature" },
        React.createElement(Modal, { picto: "signature", title: t('Signature'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "modal-signature-content" },
                React.createElement("div", { className: "modal-signature-heading" },
                    React.createElement(Text, { value: t('Sign here') }),
                    React.createElement(Button, { style: "plain", label: t('Clear'), onPress: onPressClearSignature })),
                React.createElement("div", { className: "modal-signature-content-signature" },
                    React.createElement(SignaturePad, { canvasProps: { className: 'signature-pad' }, ref: signaturePad, onEnd: () => {
                            var _a, _b;
                            return setSignatureData(Object.assign(Object.assign({}, signatureDataValue), { signatureBase64: (_b = (_a = signaturePad.current) === null || _a === void 0 ? void 0 : _a.getTrimmedCanvas().toDataURL('image/png')) !== null && _b !== void 0 ? _b : '' }));
                        } })),
                React.createElement("div", { className: "modal-signature-content-contact-fields" },
                    React.createElement(FormGroup, null,
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { name: "firstName", label: t('First Name'), value: signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.firstName, onChange: (value) => setSignatureData(Object.assign(Object.assign({}, signatureDataValue), { firstName: value })) })),
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { name: "lastName", label: t('Last Name'), value: signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.lastName, onChange: (value) => setSignatureData(Object.assign(Object.assign({}, signatureDataValue), { lastName: value })) }))),
                    React.createElement(FormGroup, null,
                        React.createElement(FormField, null,
                            React.createElement(FormEmail, { name: "email", label: t('Email'), value: signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.email, onChange: (value) => setSignatureData(Object.assign(Object.assign({}, signatureDataValue), { email: value })) })),
                        React.createElement(FormField, null,
                            React.createElement(FormDate, { name: "date", label: t('Date'), value: (_a = signatureDataValue === null || signatureDataValue === void 0 ? void 0 : signatureDataValue.date) !== null && _a !== void 0 ? _a : new Date().toISOString(), onChange: (value) => setSignatureData(Object.assign(Object.assign({}, signatureDataValue), { date: value })), time: false }))))))));
}
